import React from 'react';
import { Trans } from 'react-i18next';

import './TrustInfo.scss';

const TrustInfo: React.FC = () => {
  return (
    <div styleName="trust-info">
      <article styleName="info-card">
        <div styleName="info-card__preview">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.9998 17.27L17.1698 20.39C17.5498 20.62 18.0198 20.28 17.9198 19.85L16.5498 13.97L21.1098 10.02C21.4398 9.72997 21.2698 9.17997 20.8198 9.13997L14.8098 8.62997L12.4598 3.08997C12.2898 2.67997 11.7098 2.67997 11.5398 3.08997L9.18981 8.62997L3.17981 9.13997C2.73981 9.17997 2.55981 9.72997 2.89981 10.02L7.45981 13.97L6.08981 19.85C5.98981 20.28 6.45981 20.62 6.83981 20.39L11.9998 17.27Z"
              fill="#A6CBFF"
            />
          </svg>
        </div>
        <div styleName="info-card__content">
          <span styleName="info-card__content-text">
            <Trans i18nKey="T.TRUST-INFO.<strong>1500PLUS</strong>-TOP-PROFESSIONALS" />
          </span>
        </div>
      </article>

      <article styleName="info-card">
        <div styleName="info-card__preview">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 5H17V4C17 3.45 16.55 3 16 3H8C7.45 3 7 3.45 7 4V5H5C3.9 5 3 5.9 3 7V8C3 10.55 4.92 12.63 7.39 12.94C8.02 14.44 9.37 15.57 11 15.9V19H8C7.45 19 7 19.45 7 20C7 20.55 7.45 21 8 21H16C16.55 21 17 20.55 17 20C17 19.45 16.55 19 16 19H13V15.9C14.63 15.57 15.98 14.44 16.61 12.94C19.08 12.63 21 10.55 21 8V7C21 5.9 20.1 5 19 5ZM5 8V7H7V10.82C5.84 10.4 5 9.3 5 8ZM19 8C19 9.3 18.16 10.4 17 10.82V7H19V8Z"
              fill="#A6CBFF"
            />
          </svg>
        </div>
        <div styleName="info-card__content">
          <span styleName="info-card__content-text">
            <Trans i18nKey="T.TRUST-INFO.<strong>48of50</strong>-AND-<strong>200000PLUS</strong>-PROFESSIONAL-REVIEWS" />
          </span>
        </div>
      </article>

      <article styleName="info-card">
        <div styleName="info-card__preview">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.8505 6.85L18.2905 8.29L13.4105 13.17L10.1205 9.88C9.73047 9.49 9.10047 9.49 8.71047 9.88L2.71047 15.89C2.32047 16.28 2.32047 16.91 2.71047 17.3C3.10047 17.69 3.73047 17.69 4.12047 17.3L9.41047 12L12.7005 15.29C13.0905 15.68 13.7205 15.68 14.1105 15.29L19.7005 9.71L21.1405 11.15C21.4505 11.46 21.9905 11.24 21.9905 10.8V6.5C22.0005 6.22 21.7805 6 21.5005 6H17.2105C16.7605 6 16.5405 6.54 16.8505 6.85Z"
              fill="#A6CBFF"
            />
          </svg>
        </div>
        <div styleName="info-card__content">
          <span styleName="info-card__content-text">
            <Trans i18nKey="T.TRUST-INFO.<strong>71POINT749</strong>-JOBS-COMPLETED-SO-FAR" />
          </span>
        </div>
      </article>
    </div>
  );
};

export default TrustInfo;
